<template>
    <b-col id="myContainer">
        <!--<div class="my-3">-->
            <!-- our triggering (target) element -->
            <b-button id="exPopoverReactive1"
                   :disabled="popoverShow"
                   ref="button"
                      size="lg" variant="link" class="with-margin" :block=true>
                Advanced parameters...
            </b-button>
        <!--</div>-->

        <!-- Our popover title and content render container -->
        <!-- We use placement 'auto' so popover fits in the best spot on viewport -->
        <!-- We specify the same container as the trigger button, so that popover is close to button -->
        <b-popover target="exPopoverReactive1"
                   triggers="click"
                   :show.sync="popoverShow"
                   placement="auto"
                   container="myContainer"
                   ref="popover"
                   @show="onShow"
                   @shown="onShown"
                   @hidden="onHidden">
            <template slot="title">
                <b-btn @click="onClose" class="close" aria-label="Close">
                    <span class="d-inline-block" aria-hidden="true">&times;</span>
                </b-btn>
                Advanced parameters
            </template>
            <div>
                <b-form-group>
                    <b-form-group>
                        FDR/FWER for step 1
                        <b-form-input type=number v-model="params.p_value1" step=0.01 min=0 max=1></b-form-input>
                    </b-form-group>
                    <b-form-group>
                        Correction method for step 1
                        <b-form-select v-model="params.correction_1" :options="stats_methods" ></b-form-select>
                    </b-form-group>
                    <b-form-group>
                        FDR/FWER for step 2
                        <b-form-input type=number v-model="params.p_value2" step=0.01 min=0 max=1></b-form-input>
                    </b-form-group>
                    <b-form-group>
                        Correction method for step 2
                        <b-form-select v-model="params.correction_2" :options="stats_methods"></b-form-select>
                    </b-form-group>
                    <b-form-group>
                        Minimal number of genes annotated to a term
                        <b-form-input type=number v-model="params.min_genes" min=1></b-form-input>
                    </b-form-group>
                    <b-form-group>
                        Number of quantiles
                        <b-form-input type=number v-model="params.quantiles" min=2></b-form-input>
                    </b-form-group>
                </b-form-group>

                <!--<b-alert show class="small">-->
                    <!--<strong>Current Values:</strong><br>-->
                    <!--Name: <strong>{{ input1 }}</strong><br>-->
                    <!--Color: <strong>{{ input2 }}</strong>-->
                <!--</b-alert>-->
                <b-btn @click="$emit('on_reset')" size="sm" variant="danger">Reset</b-btn>
                <b-btn @click="onOk" size="sm" variant="primary">Ok</b-btn>
            </div>
        </b-popover>
    </b-col>
</template>

<script>
    export default {
        name: 'Parameters',
        props: ['params', 'default_params'],
        data () {
            return {
                stats_methods: [
                    {value: "holm", text: "Holm" }, 
                    {value: "hochberg", text:"Hochberg"}, 
                    {value: "hommel", text: "Hommel"},
                    {value: "bonferroni", text: "Bonferroni"},
                    {value: "BH", text: "Benjamini-Hochberg"}, 
                    {value: "BY", text: "Benjamini-Yekutieli"}, 
                    {value: "fdr", text: "False Discovery Rate (FDR)"}
                ],
                popoverShow: false,

            }
        },
        watch: {

        },
        methods: {
            onReset() {
                this.params = Object.assign({}, this.default_params)
            },
            onClose () {
                this.popoverShow = false;
            },
            onOk () {
                this.onClose();
            },
            onShow () {
                /* This is called just before the popover is shown */
                /* Reset our popover "form" variables */

            },
            onShown () {
                /* Called just after the popover has been shown */
                /* Transfer focus to the first input */
            },
            onHidden () {
                /* Called just after the popover has finished hiding */
                /* Bring focus back to the button */
                this.focusRef(this.$refs.button);
            },
            focusRef (ref) {
                /* Some references may be a component, functional component, or plain element */
                /* This handles that check before focusing, assuming a focus() method exists */
                /* We do this in a double nextTick to ensure components have updated & popover positioned first */
                this.$nextTick(() => {
                    this.$nextTick(() => { (ref.$el || ref).focus() });
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Parameters.vue